const initialState = {
  activeSubmission: {
    submissionId: '-1',
    clientInfo: '',
    submissionItemList: [],
    submissionWorkTypeTotal: [],
    submissionTotal: '',
  },
};

const submissions = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_SUBMISSION':
      return {
        ...state,
        activeSubmission: action.submission,
      };
    case 'RESET_ACTIVE_SUBMISSION':
      return {
        ...state,
        activeSubmission: initialState.activeSubmission,
      };
    case 'SET_ACTIVE_SUBMISSION_AFTER_ITEM_DELETE_OR_CREATE':
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          submissionItemList: action.submission.submissionItemList,
          submissionTotal: action.submission.submissionTotal,
          submissionWorkTypeTotal: action.submission.submissionWorkTypeTotal,
          // Sections rafraîchies après une mutation d'item : en mode 'work_type', le serveur
          // vient peut-être d'auto-semer une section — sans ça l'éditeur l'ignorait et rendait
          // les items à plat (le PDF/reload la voyaient). Garde `!== undefined` : un appelant
          // qui ne renvoie pas les sections ne doit pas les effacer.
          submissionSections: action.submission.submissionSections !== undefined
            ? action.submission.submissionSections
            : state.activeSubmission.submissionSections,
        },
      };
    case 'OPTIMISTIC_PATCH_ITEM':
      // Sauvegarde optimiste de l'édition en place : applique le patch à l'item
      // localement AVANT la réponse serveur (cellule + totaux mis à jour sans attendre).
      // Le serveur réconcilie ensuite via SET_ACTIVE_SUBMISSION_AFTER_ITEM_DELETE_OR_CREATE ;
      // en cas d'échec, le composant redispatche le patch d'origine pour revenir en arrière.
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          submissionItemList: (state.activeSubmission.submissionItemList || []).map((it) => (
            it.id === action.id ? { ...it, ...action.patch } : it
          )),
        },
      };
    case 'OPTIMISTIC_SET_ITEMS':
      // Remplacement optimiste de la liste d'items (ex. suppression appliquée tout de
      // suite, ou retour en arrière si la requête échoue). Le serveur réconcilie ensuite.
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          submissionItemList: action.items,
        },
      };
    case 'SET_ACTIVE_SUBMISSION_AFTER_CLIENT_INFO_UPDATE':
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          clientInfo: action.clientInfo,
        },
      };
    case 'SET_ACTIVE_SUBMISSION_ITEMS_AFTER_PRIORITY_CHANGE':
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          submissionItemList: action.submission.submissionItemList,
        },
      };
    case 'SET_ACTIVE_SUBMISSION_SECTIONS':
      return {
        ...state,
        activeSubmission: {
          ...state.activeSubmission,
          submissionSections: action.sections,
        },
      };
    default:
      return state;
  }
};

export default submissions;
